<template>
	<!-- DC: 팀 관리. 팀(직원코드관리의 '팀')마다 팀장과 팀원을 한 표로 보고, 옮기고, 팀장을 지정하고, 위클리 사용 권한을 정한다(DE). -->
	<div class="content sa20">
		<div class="section">
			<div class="section-tit">팀 관리</div>
			<div class="tab-btn">
				<button type="button" class="btn tab" v-bind:class="{ active: tab === 'team' }" @click="tab = 'team'">팀과 팀원</button>
				<button type="button" class="btn tab" v-bind:class="{ active: tab === 'log' }" @click="tab = 'log'">변경 이력</button>
			</div>

			<div v-if="stale" class="sa20-stale">
				저장했지만 목록을 다시 불러오지 못했습니다. 아래 표는 저장 전 모습일 수 있습니다.
				<button type="button" class="btn btn-xxsm btn-light" :disabled="busy" @click="load">다시 불러오기</button>
			</div>
			<div class="tab-con" v-if="tab === 'team'">
				<div class="txt-c--grey mb-1">
					※ 팀장은 직급과 상관없이 지정합니다. 직급이 '팀장' 인 직원은 지정하지 않아도 팀장으로 봅니다. 팀장은 같은 팀 직원의
					매수고객 카드와 주간 KPI 를 봅니다. 다른 팀으로 옮기면 팀장 지정은 풀립니다.
					<br />※ Weekly 사용: 기본은 팀장 이상(팀장·이사·대표, 이 화면에서 지정한 팀장 포함)이 씁니다(관리자는 언제나). 체크를 바꾸면 그 직원만 기본과 다르게 부여하거나 회수하고,
					'기본' 이 붙은 직원은 직급과 팀장 지정을 따릅니다. 권한이 없으면 Weekly 메뉴와 버튼이 보이지 않습니다.
					직원은 자기가 만든 Weekly 와 공용 Weekly, 자기 고객 리드만 보고, 전체는 관리자만 봅니다.
				</div>
				<div class="sa20-add">
					<input type="text" class="form-control" maxlength="40" placeholder="새 팀 이름" v-model.trim="newName" @keyup.enter="addTeam" />
					<button type="button" class="btn btn-sm btn-primary" :disabled="busy || !newName" @click="addTeam">팀 추가</button>
				</div>
				<div class="table-wrap">
					<table class="table sa20-tbl">
						<colgroup>
							<col />
							<col width="12%" />
							<col width="12%" />
							<col width="20%" />
							<col width="16%" />
							<col width="11%" />
						</colgroup>
						<tr>
							<th>직원</th>
							<th>직급</th>
							<th>팀장</th>
							<th>팀</th>
							<th>Weekly 사용</th>
							<th title="KPI·배정 설정에서 바꿉니다">매수배정 담당</th>
						</tr>
						<template v-for="t in groups" :key="'g_' + (t.team_uid || 'none')">
							<tr class="sa20-team">
								<td colspan="6">
									<div class="sa20-team__row">
										<template v-if="editUid && editUid === t.team_uid">
											<input type="text" class="form-control sa20-name" maxlength="40" v-model.trim="editName" @keyup.enter="saveName(t)" />
											<button type="button" class="btn btn-xxsm btn-primary" :disabled="busy || !editName" @click="saveName(t)">저장</button>
											<button type="button" class="btn btn-xxsm btn-secondary" @click="editUid = null">취소</button>
										</template>
										<b v-else class="sa20-team__name">{{ t.label }}</b>
										<span class="sa20-sub">{{ t.members.length }}명</span>
										<template v-if="t.team_uid">
											<span class="sa20-team__lead">팀장</span>
											<select
												v-if="t.members.length"
												class="form-control sm select sa20-leader"
												:value="t.leader_uid || ''"
												:disabled="busy"
												@change="setLeader(t, $event)"
											>
												<option value="">지정 안 함</option>
												<option v-for="m in t.members" :key="'lo_' + m.mem_uid" :value="m.mem_uid">{{ m.mem_name }}</option>
											</select>
											<span v-else class="txt-c--grey">-</span>
											<span v-if="rankOnly(t).length" class="sa20-sub">직급 팀장: {{ rankOnly(t).join(', ') }}</span>
											<span class="sa20-team__btns" v-if="editUid !== t.team_uid">
												<button type="button" class="btn btn-xxsm btn-light" :disabled="busy" @click="startRename(t)">이름 변경</button>
												<button v-if="!t.members.length" type="button" class="btn btn-xxsm btn-light" :disabled="busy" @click="offTeam(t)">사용 안 함</button>
											</span>
										</template>
										<span v-else class="sa20-sub">팀이 없으면 팀장 범위에 들어가지 않습니다.</span>
									</div>
								</td>
							</tr>
							<tr v-for="m in t.members" :key="'m_' + m.mem_uid">
								<td class="txt-left">
									<b>{{ m.mem_name }}</b>
									<span v-if="m.mem_type === 'master'" class="sa20-sub">관리자</span>
								</td>
								<td>{{ m.rank_name || '-' }}</td>
								<td>
									<span v-if="m.designated" class="sa20-on">지정</span>
									<span v-else-if="m.rank_leader">직급</span>
									<span v-else class="txt-c--grey">-</span>
								</td>
								<td>
									<select class="form-control sm select sa20-move" :value="m.team_uid || ''" :disabled="busy" @change="move(m, $event)">
										<option value="">팀 없음</option>
										<option v-for="o in data.teams" :key="'to_' + o.team_uid" :value="o.team_uid">{{ o.label }}</option>
									</select>
								</td>
								<td>
									<span v-if="m.mem_type === 'master'" class="txt-c--grey">언제나(관리자)</span>
									<label v-else class="sa20-weekly">
										<input type="checkbox" :checked="m.weekly_use" :disabled="busy" @change="setWeekly(m, $event)" />
										<span :class="m.weekly_use ? 'sa20-on' : 'txt-c--grey'">{{ m.weekly_use ? '사용' : '안 함' }}</span>
										<span class="sa20-sub">{{ m.weekly_default ? '기본' : (m.weekly_use ? '부여' : '회수') }}</span>
									</label>
								</td>
								<td>
									<span v-if="m.lead_manage" class="sa20-on">담당</span>
									<span v-else class="txt-c--grey">-</span>
								</td>
							</tr>
							<tr v-if="!t.members.length">
								<td colspan="6" class="txt-c--grey">팀원이 없습니다.</td>
							</tr>
						</template>
					</table>
				</div>
			</div>

			<div class="tab-con" v-if="tab === 'log'">
				<div class="table-wrap">
					<table class="table">
						<tr>
							<th>시각</th>
							<th>구분</th>
							<th>직원</th>
							<th>팀</th>
							<th>이전</th>
							<th>이후</th>
							<th>바꾼 사람</th>
						</tr>
						<tr v-for="l in data.logs" :key="'l_' + l.log_uid">
							<td>{{ l.reg_at }}</td>
							<td>{{ KIND[l.kind] || l.kind }}</td>
							<td>{{ l.mem_name || '-' }}</td>
							<td>{{ teamName(l.team_uid) }}</td>
							<td class="txt-left">{{ logVal(l, l.before_val) }}</td>
							<td class="txt-left">{{ logVal(l, l.after_val) }}</td>
							<td>{{ l.reg_name || '-' }}</td>
						</tr>
						<tr v-if="!data.logs.length">
							<td colspan="7">변경 이력이 없습니다.</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// DC 의 위클리 열람범위 이력(kind 'weekly')을 읽을 때만 쓴다. DE 부터는 사용 권한(kind 'weekly_use')을 바꾼다.
const WEEKLY = [
	{ v: 'self', label: '본인' },
	{ v: 'team', label: '팀' },
	{ v: 'all', label: '전체' },
];
const KIND = {
	team_move: '팀 이동',
	leader: '팀장',
	team_add: '팀 추가',
	team_name: '팀 이름',
	team_off: '팀 사용 안 함',
	weekly: '위클리 열람범위',
	weekly_use: 'Weekly 사용',
};

export default {
	name: 'SystemAdmin20',
	data() {
		return {
			WEEKLY,
			KIND,
			tab: 'team',
			busy: false,
			data: { teams: [], no_team: [], staff: [], logs: [] },
			newName: '',
			editUid: null,
			editName: '',
			stale: false,
		};
	},
	computed: {
		groups() {
			const out = this.data.teams.slice();
			out.push({ team_uid: null, label: '팀 없음', leader_uid: null, leaders: [], members: this.data.no_team });
			return out;
		},
	},
	created() {
		this.load();
	},
	methods: {
		async load() {
			const re = await this.$apiGET('/admin/api/mem/team/list');
			if (!re || !re.teams) return false;
			this.data = re;
			this.stale = false;
			return true;
		},
		async post(path, body) {
			this.busy = true;
			try {
				const re = await this.$apiPOST(path, body);
				if (!re || !re.ok) return null;
				// 저장은 됐는데 다시 읽기만 실패하면 표가 저장 전 값을 보인다. 그 사실을 띄우고 다시 불러오기를 둔다(codex 리뷰).
				if (!(await this.load())) this.stale = true;
				return re;
			} finally {
				this.busy = false;
			}
		},
		rankOnly(t) {
			return t.members.filter((m) => m.rank_leader && !m.designated).map((m) => m.mem_name);
		},
		teamName(uid) {
			if (uid == null) return '-';
			const t = this.data.teams.find((x) => x.team_uid === Number(uid));
			return t ? t.label : '(사용 안 함)';
		},
		logVal(l, v) {
			if (v == null || v === '') return '-';
			if (l.kind === 'weekly') return (WEEKLY.find((o) => o.v === v) || {}).label || v;
			return v;
		},
		async addTeam() {
			if (!this.newName || this.busy) return;
			const re = await this.post('/admin/api/mem/team/add', { name: this.newName });
			if (re) this.newName = '';
		},
		startRename(t) {
			this.editUid = t.team_uid;
			this.editName = t.name;
		},
		async saveName(t) {
			if (!this.editName || this.busy) return;
			const re = await this.post('/admin/api/mem/team/rename', { teamUid: t.team_uid, name: this.editName });
			if (re) this.editUid = null;
		},
		async offTeam(t) {
			if (!confirm(`'${t.label}' 팀을 사용 안 함으로 바꿉니다. 직원상세와 검색의 팀 목록에서 빠집니다.`)) return;
			await this.post('/admin/api/mem/team/off', { teamUid: t.team_uid });
		},
		async setLeader(t, ev) {
			const v = ev.target.value;
			const next = v ? t.members.find((m) => m.mem_uid === Number(v)) : null;
			const msg = next
				? `${t.label} 팀장을 ${next.mem_name}(으)로 지정합니다. ${next.mem_name}은(는) 같은 팀 직원의 매수고객과 KPI 를 보게 됩니다.`
				: `${t.label} 팀장 지정을 풉니다.`;
			if (!confirm(msg)) {
				ev.target.value = t.leader_uid || '';
				return;
			}
			const re = await this.post('/admin/api/mem/team/leader', { teamUid: t.team_uid, memUid: next ? next.mem_uid : null });
			if (!re) ev.target.value = t.leader_uid || '';
		},
		async move(m, ev) {
			const v = ev.target.value;
			const to = v ? this.data.teams.find((x) => x.team_uid === Number(v)) : null;
			const from = m.team_uid != null ? this.teamName(m.team_uid) : '팀 없음';
			let msg = `${m.mem_name}을(를) ${from}에서 ${to ? to.label : '팀 없음'}(으)로 옮깁니다.`;
			if (m.designated) msg += `\n${from} 팀장 지정이 풀립니다.`;
			if (!confirm(msg)) {
				ev.target.value = m.team_uid || '';
				return;
			}
			const re = await this.post('/admin/api/mem/team/move', { memUid: m.mem_uid, teamUid: to ? to.team_uid : null });
			if (!re) ev.target.value = m.team_uid || '';
		},
		async setWeekly(m, ev) {
			const on = !!ev.target.checked;
			const msg = on
				? `${m.mem_name}에게 Weekly 사용 권한을 줍니다. Weekly 메뉴가 보이고, 자기가 만든 Weekly 와 공용 Weekly, 자기 고객 리드를 봅니다.`
				: `${m.mem_name}의 Weekly 사용 권한을 회수합니다. Weekly 메뉴와 버튼이 사라집니다.\n이미 고객에게 보낸 링크는 그대로 열리고, 그 열람 확인과 링크 회수는 관리자가 합니다.`;
			if (!confirm(msg)) {
				ev.target.checked = m.weekly_use;
				return;
			}
			const re = await this.post('/admin/api/mem/team/weekly', { memUid: m.mem_uid, use: on ? 'Y' : 'N' });
			if (!re) ev.target.checked = m.weekly_use;
			else if (this.stale) {   // 다시 읽지 못했어도 저장한 값으로 보인다
				m.weekly_use = !!re.allowed;
				m.weekly_default = !!re.byDefault;
			}
		},
	},
};
</script>

<style lang="scss">
@import "@/assets/css/design-tokens.scss";

.sa20 {
	.sa20-stale {
		margin-bottom: $dt-spacing-cell-head;
		color: $dt-color-danger;
	}
	.table td.txt-left,
	.table th.txt-left {
		text-align: left;
	}
	.sa20-add {
		display: flex;
		gap: 6px;
		align-items: center;
		margin-bottom: $dt-spacing-cell-head;
		.form-control {
			width: 240px;
		}
	}
	.sa20-tbl td {
		white-space: nowrap;
	}
	.sa20-team td {
		background: $dt-color-surface-sunken;
		text-align: left;
		border-top: 1px solid $dt-color-line-strong;
	}
	.sa20-team__row {
		display: flex;
		align-items: center;
		gap: 10px;
		min-height: $dt-spacing-control-height;
	}
	.sa20-team__name {
		font-size: 14px;
	}
	.sa20-team__lead {
		margin-left: 14px;
		color: $dt-color-ink-muted;
	}
	.sa20-team__btns {
		margin-left: auto;
		display: inline-flex;
		gap: 6px;
	}
	.table .form-control.sa20-leader,
	.table .form-control.sa20-name {
		width: 160px;
	}
	.table .form-control.sa20-move {
		width: 170px;
	}
	.sa20-weekly {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		margin: 0;
		cursor: pointer;
		input { margin: 0; }
	}
	.sa20-sub {
		@include dt-type-dense;
		color: $dt-color-ink-faint;
	}
	.sa20-on {
		color: $dt-color-success-ink;
		font-weight: 600;
	}
}
</style>
